<template>
  <div>
    <div class="img-top">
      <div class="text-title">其他类设备</div>
      <!--			<div class="text-subtitle">解决你的临时用电需求 专注用电需求</div>-->
    </div>

    <div style="height: 100%;background-color: #fff;padding-left: 15px;">
      <div class="section-tabs">
        <RentTabs :tabsList="typeList" tabType="设备类型" @active="typeChange"></RentTabs>
        <!--        <RentTabs :tabsList="lightList" tabType="设备型号" @active="sbChange"></RentTabs>-->
        <RentTabs :tabsList="paixu" tabType="排序" @active="paixuChange"></RentTabs>
        <div style="display: flex;">
          <el-row>
            <el-col :span="2">
              <div class="text-start" style="padding: 7px 0;margin-top: 5px;">设备型号</div>
            </el-col>
            <el-col :span="12">
              <div class="tabs-box" style="display: flex;flex-wrap: wrap;">
                <el-input v-model="query.lightingTypeLabel" placeholder="请输入设备型号"
                          style="width: 300px"
                          @change="getEquipmentList"
                ></el-input>
              </div>
            </el-col>
            <el-col :span="10"></el-col>
          </el-row>
        </div>
        <!--        <RentTabs :tabsList="dianya" tabType="电压" @active="dianyaChange"></RentTabs>-->
        <!--        <RentTabs :tabsList="rongliang" tabType="容量" @active="rongliangChange"></RentTabs>-->
        <!--				<RentTabs :tabsList="paixu"  tabType="排序" @active="paixuChange"></RentTabs>-->

        <!-- 子组件进行模糊查询 点击后会被父组件的数据污染 暂不知道如何解决  只能在父组件进行模糊查询在传入子组件  并修改厂商的页面样式 -->
        <!-- -----------------------厂商 ------------------------------------------- -->


        <div v-if="change%2==0">


          <div style="display: flex;align-items: center;">
            <div style="font-size: 0.14rem;color: #8F8F8F;">厂商</div>
            <div style="margin: 10px 0;display: flex;margin-left: 75px;">

              <input type="text" v-model="message">
              <button style="margin-left: 20px;" @click="serach">搜索</button>
            </div>
            <div style="font-size: 0.14rem;margin-left: 960px;cursor: pointer;" @click="addchange">收起</div>
          </div>
          <div style="margin-left: 92px;">
            <RentTabs :tabsList="changshang" :isBorder="false" @active="changshangChange"></RentTabs>
          </div>
        </div>


        <div v-if="change%2 !==0  && changshang !== null && changshang.length > 0"
             style="display: flex;align-items: center;">
          <div style="font-size: 0.14rem;color: #8F8F8F;">厂商</div>
          <div style="height: 41px;overflow:hidden;width: 90%;margin-left: 65px;">
            <RentTabs :tabsList="changshang" :isBorder="false" @active="changshangChange"></RentTabs>
          </div>
          <div style="font-size: 0.14rem;margin-left: -32px;cursor: pointer;" @click="addchange">更多</div>
        </div>

        <!-- -----------------------厂商 ------------------------------------------- -->

        <!-- <RentTabs :tabsList="changshang" :isBorder="false" tabType="厂商" @active="changshangChange"></RentTabs> -->
      </div>
    </div>
    <div class="content">
      <div class="center flex-row wrap">
        <div style="margin: 0 10px 0 5px" v-for="(item, i) in equipmentList" :key="i" class="card-item">
          <HomeListCard :detail="item" :type="item.serviceType"
                        :get-dict-value-by-type-and-value="getDictValueByTypeAndValue"
                        @updataState="handleUpdateState()"></HomeListCard>
        </div>
      </div>
    </div>
    <div style="display: flex; justify-content: center;padding-bottom: 20px;padding-top: 20px" v-if="total > 0">
      <el-pagination background layout="prev, pager, next,total" :total="total" :page-size="query.pageSize"
                     @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import RentTabs from "../../components/rentTabs.vue";
import HomeListCard from "../../components/homeListCard.vue";
import {equipmentListApi} from "../../http/api/ordinary.js";
import {equipmentBusinessList, equipmentVoltageApi} from "../../http/factory/add-eme.js";
import {getDictByType} from "@/utils/dictUtils";

export default {
  components: {
    RentTabs,
    HomeListCard,
  },
  data() {
    return {
      typeMap: {},
      typeList: [{
        key: null,
        value: "不限",
      },],
      lightList: [],
      dianya: [{
        key: null,
        value: "不限",
      },],
      rongliang: [{
        key: null,
        value: "不限",
      },],
      paixu: [
          {
            key: null,
            value: "不限",
          },

        {
          key: 1,
          value: "销量",
        },
        {
          key: 2,
          value: "价格",
        },
        {
          key: 3,
          value: "评分",
        },
      ],
      changshang: [{
        key: null,
        value: "不限",
      },],
      change: 1,
      message: '',
      equipmentList: [],
      query: {
        serviceDictValue: 2,
        pageSize: 15,
        pageNum: 1,
        voltageKv: null,
        volumeKva: null,
        lightingTypeLabel: null,
      },
      total: 0,
    };
  },
  created() {
    this.init();
    this.getEquipmentList();
  },
  methods: {
    handleUpdateState() {
      this.getEquipmentList();
    },
    getDictValueByTypeAndValue(type, value) {
      /*if (type == "volume_kva"){
        if (this.rongliangMap[value]) return this.rongliangMap[value]
        else return value;
      }
      else */
      if (type == "facility_type") {
        if (this.typeMap[value]) return this.typeMap[value]
        else return value;
      }
      return value;
    },
    init() {
      getDictByType(
          'facility_type'
      ).then(response => {
        //其他类
        response.filter(item => {
          return item.remark.trim() == "qt"
        }).forEach(item => {
          this.typeList.push({
            value: item.dictLabel,
            key: item.dictValue,
          })
          this.typeMap[item.dictValue] = item.dictLabel
        })

        /*let res = response.filter(item => Number.parseInt(item.dictValue) >= 20 )
        console.log(res)
        for (let item of res) {
          this.typeList.push({
            key: item.dictValue,
            value: item.dictLabel,
          });
        }*/
      })

      /*getDictByType(
          'lighting_type'
      ).then(res => {

        for (let item of res) {
          this.lightList.push({
            key: item.dictValue,
            value: item.dictLabel,
          });
        }
      })*/

      //电压
      equipmentVoltageApi({
        serviceType: 0
      }).then((res) => {
        for (let item of res) {
          this.dianya.push({
            key: item.id,
            value: item.voltage,
          });
        }
      });
      //厂商
      equipmentBusinessList({
        pageNumber: 1,
        serviceDictValue: this.query.serviceDictValue,
        pageSize: 9999
      }).then((res) => {
        for (let item of res.rows) {
          this.changshang.push({
            key: item.id,
            value: item.companyName,
          });
        }
      });

    },

    serach() {

      equipmentBusinessList({
        pageNumber: 1,
        name: this.message,
        serviceDictValue: this.query.serviceDictValue,
        pageSize: 999
      }).then((res) => {
        this.changshang = [{
          key: null,
          value: "不限",
        }]
        for (let item of res.rows) {
          this.changshang.push({
            key: item.id,
            value: item.companyName,
          });
        }
        console.log(this.changshang)
      });
    },

    addchange() {
      this.change++
    },
    getEquipmentList() {
      equipmentListApi(this.query).then((res) => {
        this.equipmentList = res.rows;
        this.total = res.total;
      });
    },
    handleCurrentChange(val) {
      this.query.pageNum = val;
      this.getEquipmentList();
    },
    typeChange(id) {
      this.query.facilityTypeDictValue = id;
      this.getEquipmentList();
    },
    sbChange(id) {

      this.query.lightingTypeValue = id;
      this.getEquipmentList();
    },
    rongliangChange(id) {
      this.query.volumeKva = id;
      this.getEquipmentList();
    },
    paixuChange(id, sort) {
      this.query.paixu = id;
      this.query.sort = sort
      this.getEquipmentList();
    },
    changshangChange(id) {
      this.query.customerId = id;
      this.getEquipmentList();
    },
  },
};
</script>

<style scoped>
.img-top {
  height: 2.1rem;
  background-color: #c4c4c4;
  background-image: url("../../assets/image/tingdian.png");
  background-size: 100% 100%;
  padding: 0.59rem 0 0 2rem;
  -webkit-box-sizing: border-box;
}

.text-title {
  font-size: 0.3rem;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 0.42rem;
  margin-bottom: 0.14rem;
  font-style: italic;
  letter-spacing: 0.02rem;
}

.text-subtitle {
  font-size: 0.16rem;
  font-family: PingFang SC-Regular, PingFang SC;
  color: #ffffff;
  line-height: 0.22rem;
  font-style: italic;
  letter-spacing: 0.01rem;
}

.section-tabs {
  /* padding: 0 2rem; */
  background: #ffffff;
  width: 15.19rem;
  margin: 0 auto;
}

.center {
  width: 15.19rem;
  margin: 0 auto;
  padding-top: 20px;
}

.card-item {
  margin-bottom: 0.06rem;
}

.fenye {
  margin-top: 0.4rem;
}

/* -------推荐发电车 end ---- */
.shoppingCar {
  position: fixed;
  top: 600px;
  right: 10px;
  text-align: center;
  cursor: pointer;
  border: 1px solid #ccc;
  padding: 5px;
  border-radius: 2px;
}

.shoppingCar:hover {
  background-color: #ccc !important;
}

/*  ------------------搜索栏*/
.section-tabs {
  width: 15.19rem;
  background: #ffffff;
  margin: 0 auto;
}

.text-start {
  width: .96rem;
  font-size: .14rem;
  font-family: PingFang SC-Regular, PingFang SC;
  color: #8F8F8F;
  line-height: .20rem;
}

.tabs-box {
  width: 1130px;
  max-height: 155px;
}
</style>
